var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadClosedOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 550,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 701,
    y: 481,
    width: 550,
    height: 550
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 514,
    width: 445,
    height: 416
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 514,
    width: 445,
    height: 416
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 514,
    width: 445,
    height: 416
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 845,
    y: 629,
    width: 265,
    height: 247
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 845,
    y: 629,
    width: 265,
    height: 247
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 845,
    y: 629,
    width: 265,
    height: 247
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-701 -481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704 757C704 606.226 826.226 484 977 484 1127.77 484 1250 606.226 1250 757 1250 907.774 1127.77 1030 977 1030 826.226 1030 704 907.774 704 757Z",
    fill: "#C84043",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743 757C743 627.765 847.765 523 977 523 1106.23 523 1211 627.765 1211 757 1211 886.235 1106.23 991 977 991 847.765 991 743 886.235 743 757Z",
    fill: "#C84043",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.656 345.833 222.63 51.875C216.146 40.2031 199.286 40.2031 192.802 51.875L23.3437 345.833C16.8594 357.505 25.0729 371.771 38.4739 371.771L207.5 371.771 376.526 371.771C389.927 371.771 398.141 357.505 391.656 345.833ZM194.531 121.042 220.469 121.042 220.469 272.344 194.531 272.344 194.531 121.042ZM207.5 332.865C195.396 332.865 185.885 323.354 185.885 311.25 185.885 299.146 195.396 289.635 207.5 289.635 219.604 289.635 229.115 299.146 229.115 311.25 229.115 323.354 219.604 332.865 207.5 332.865Z",
    fill: "#F6F6F6",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.06988 0 0 1 755 515)"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 65,
    height: 242,
    stroke: "#F6F6F6",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#F6F6F6",
    fillOpacity: 1,
    transform: "matrix(-1 0 0 1 1008.5 623.5)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.963 20.5833 138.037 20.5833 135.618 166.956 111.381 166.956 108.963 20.5833Z",
    stroke: "#282828",
    strokeWidth: 2.57294,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    fill: "#404040",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.06883 0 0 1 846 629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.083 203.26C144.083 214.628 134.868 223.844 123.5 223.844 112.132 223.844 102.917 214.628 102.917 203.26 102.917 191.892 112.132 182.677 123.5 182.677 134.868 182.677 144.083 191.892 144.083 203.26Z",
    stroke: "#282828",
    strokeWidth: 2.57294,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    fill: "#404040",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(1.06883 0 0 1 846 629)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadClosedOn);
export default __webpack_public_path__ + "static/media/road_closed_on.d760e91d6aea7dd2a293a878b1f74ca1.svg";
export { ForwardRef as ReactComponent };